import React from 'react';
import { ButtonV2, Flex, IconV2, TextV2 } from '@withjoy/joykit';
import { ReactComponent as Warning } from '@assets/icons/Error-32.svg';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';

type NoBalanceStepProps = Readonly<{
  onClose: () => void;
}>;

export const NoBalanceStep: React.FC<NoBalanceStepProps> = ({ onClose }) => {
  const { tq } = useTranslation('cashFundsAdmin');

  return (
    <Flex
      flexDirection="column"
      flex={1}
    >
      <TextV2
        textAlign="center"
        fontSize={pxToRem(24)}
        fontWeight={600}
        color="mono14"
        letterSpacing="-0.024em"
        lineHeight="1.3"
        marginBottom={6}
      >
        {tq`Transfer to bank`}
      </TextV2>

      <Flex
        flex={1}
        flexDirection="column"
        justifyContent="center"
      >
        <Flex
          alignItems="center"
          borderStyle="solid"
          borderWidth="1px"
          borderColor="negative3"
          borderRadius={3}
          backgroundColor="negative1"
          padding={5}
          width="100%"
          gap={4}
        >
          <IconV2
            size="lg"
            color="negative5"
          >
            <Warning />
          </IconV2>
          <TextV2
            typographyVariant="label2"
            color="mono14"
          >
            {tq`Sorry! No balance is available for transfer.`}
          </TextV2>
        </Flex>
      </Flex>

      <ButtonV2
        onClick={onClose}
        size="lg"
        intent="neutral"
        shape="rounded"
        fullWidth
        marginTop={6}
      >
        {tq`Got it`}
      </ButtonV2>
    </Flex>
  );
};
